import { REDUCER_NAME } from './search.reducer';

export const selectFiles = state => state[REDUCER_NAME].files;

export const selectLastSearch = state => state[REDUCER_NAME].lastSearch;

export const selectIsInitialSearch = state => state[REDUCER_NAME].isInitialSearch;
